export function sortedByName(sortArray?: any[]) {
  if (!Array.isArray(sortArray)) return [];
  return [...sortArray].sort((a, b) => a.name.localeCompare(b.name));
}
